import { useLayoutEffect, useState } from 'react';

import { useEffect } from 'react';

export const useScrollPosition = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useLayoutEffect(() => {
    const updatePosition = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener('scroll', updatePosition);
    updatePosition();
    return () => window.removeEventListener('scroll', updatePosition);
  }, []);

  return scrollPosition;
};

export const useCSSVar = (variableName: string) => {
  const [value, setValue] = useState('');

  useLayoutEffect(() => {
    const computedValue = window.getComputedStyle(document.body).getPropertyValue(variableName);
    setValue(computedValue.trim());

    const observer = new MutationObserver(() => {
      const updatedValue = window.getComputedStyle(document.body).getPropertyValue(variableName);
      setValue(updatedValue.trim());
    });

    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [variableName]);

  return value;
};

const scrollToElementWithHeaderOffset = (id: string, headerSelector = '.site-header') => {
  const el = document.getElementById(id);
  if (!el) return;

  const header = document.querySelector(headerSelector);
  const offset = header instanceof HTMLElement ? header.getBoundingClientRect().height : 0;

  const elementTop = el.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({
    top: elementTop - offset,
    behavior: 'smooth',
  });
};

export const useScrollToHash = (ready: boolean, headerSelector = '.site-header') => {
  useEffect(() => {
    if (!ready) return;

    const hash = window.location.hash;
    if (!hash) return;

    const id = hash.slice(1);

    setTimeout(() => {
      scrollToElementWithHeaderOffset(id, headerSelector);
    }, 1000);
  }, [ready, headerSelector]);
};
